import axios from "axios";
import React from "react";
import Header from "../../header";
import { apiCall_domain } from "../../api";
import Select from "react-select";
import PulseLoader from "react-spinners/PulseLoader";
import SimpleReactValidator from "simple-react-validator";
class info extends React.Component {
  state = {
    cityList: [],
    city_id: null,
    countryStatesId: null,
    value: "",
    selectedCity: "انتخاب شهر",
    selectedState: "انتخاب استان",
    loading: false,
    countryStates: [],
    name: "",
    lastName: "",
    userInfo: {},
  };

  constructor() {
    super();
    this.validator = new SimpleReactValidator({
      className: "danger ",
      messages: { required: "این فیلد نباید خالی باشد" },
      autoForceUpdate: this,
    });
  }

  componentDidMount() {
    const splash = localStorage.getItem("splash");
    if (splash) {
      const parsedSplash = JSON.parse(splash);
      this.setState({
        userInfo: parsedSplash.customer_info,
        selectedCity: parsedSplash.customer_info.city.name,
        selectedState: parsedSplash.customer_info.province.name,
        countryStates: parsedSplash.cities,
      });
    }
  }

  render() {
    const stateHandleChange = (selectedState) => {
      localStorage.setItem("county", selectedState.value);
      this.setState({
        selectedState,
        countryState: selectedState.city_id,
      });
      this.setState({ cityList: selectedState.cities });
    };

    const handleChange = (selectedCity) => {
      localStorage.setItem("defaultCity", selectedCity.value);
      this.setState({ selectedCity, city_id: selectedCity.city_id });
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      this.validator.showMessages();
      if (this.validator.allValid()) {
        this.setState({ loading: true });
        const Headers = {
          Authorization: localStorage.getItem("Api_key"),
          "content-type": "application/json",
        };
        const Data = {
          name: this.state.userInfo.name,
          city_id: this.state.city_id,
        };
        axios
          .post(`${apiCall_domain}/customer/user`, Data, {
            headers: Headers,
          })
          .then((res) => {
            updateSplash().then((splash_response) => {
              localStorage.setItem(
                "splash",
                JSON.stringify(splash_response.data),
              );
              this.setState({
                loading: false,
              });
              localStorage.setItem("infoSuccess", 1);
              this.props.history.push({
                pathname: "/profile",
                phone: this.props.location.state,
              });
            });
          });
      }
    };

    const updateSplash = () => {
      const Headers = {
        Authorization: localStorage.getItem("Api_key"),
        "content-type": "application/json",
      };
      return axios.get(`${apiCall_domain}/customer/splash`, {
        headers: Headers,
      });
    };

    return (
      <>
        <Header showSearchBar={true} title={"تکمیل اطلاعات"} />
        <div className="infoSignUp">
          <div className="boxInfo">
            <div className="warning">
              <img src="/public/assets/icons/Warning.svg" alt="عکس"></img>
              <span>در صورت مغایرت سفارشات با مشکل مواجه میشود</span>
            </div>
            <div className="forms">
              <Select
                className="cities"
                name="states"
                value={this.state.selectedState}
                onChange={stateHandleChange}
                options={this.state.countryStates.map((item) => ({
                  city_id: item.id,
                  value: item.name,
                  label: item.name,
                  cities: item.cities,
                }))}
                placeholder={this.state.selectedState}
              />
              {this.validator.message(
                "states",
                this.state.countryState,
                "required",
              )}
              <Select
                className="cities"
                name="city"
                value={this.state.selectedCity}
                onChange={handleChange}
                options={this.state.cityList.map((item) => ({
                  city_id: item.id,
                  value: item.name,
                  label: item.name,
                }))}
                placeholder={this.state.selectedCity}
              />
              {this.validator.message("city", this.state.city_id, "required")}
            </div>
          </div>
          <div className="mySecContinue mySecContinueInfoBtn">
            {this.state.loading ? (
              <button className="btn disabled">
                <PulseLoader size={12} color="#fff" loading={true} />
              </button>
            ) : (
              <button onClick={(e) => handleSubmit(e)}>تایید</button>
            )}
          </div>
        </div>
      </>
    );
  }
}
export default info;
